import { reportError } from './error';

function pFileReader(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = resolve;
    fr.onerror = reject;
    fr.readAsArrayBuffer(file);
  });
}

export async function uploadToS3(file, uploadURL) {
  try {
    const { type } = file;

    const reader = await pFileReader(file);

    const uploadResponse = await fetch(uploadURL, {
      method: 'PUT',
      body: new Blob([reader.target.result], { type }),
    });

    const imageUrl = uploadResponse.url.split('?')[0];

    return imageUrl;
  } catch (error) {
    reportError(error);
    return null;
  }
}

export default uploadToS3;
